import { useTypography, FONT_FAMILIES, CONTENT_WIDTHS, TypographySettings } from '../hooks/useTypography'

interface Props {
  onClose: () => void
}

export function TypographyPanel({ onClose }: Props) {
  const { settings, updateSetting, reset } = useTypography()

  return (
    <div className="typography-panel">
      <div className="panel-header">
        <h3>Reading Settings</h3>
        <button className="close-btn" onClick={onClose} aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <div className="panel-content">
        {/* Font Family */}
        <div className="setting-group">
          <label>Font</label>
          <div className="font-options">
            {FONT_FAMILIES.map(font => (
              <button
                key={font.value}
                className={`font-option ${settings.fontFamily === font.value ? 'active' : ''}`}
                onClick={() => updateSetting('fontFamily', font.value as TypographySettings['fontFamily'])}
              >
                <span className="font-preview" style={{ fontFamily: font.css }}>Aa</span>
                <span className="font-label">{font.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Font Size */}
        <div className="setting-group">
          <label>
            Size
            <span className="value">{settings.fontSize}px</span>
          </label>
          <div className="slider-row">
            <span className="size-label small">A</span>
            <input
              type="range"
              min="14"
              max="24"
              step="1"
              value={settings.fontSize}
              onChange={(e) => updateSetting('fontSize', Number(e.target.value))}
            />
            <span className="size-label large">A</span>
          </div>
        </div>

        {/* Line Height */}
        <div className="setting-group">
          <label>
            Line Spacing
            <span className="value">{settings.lineHeight.toFixed(1)}</span>
          </label>
          <div className="slider-row">
            <span className="spacing-icon">=</span>
            <input
              type="range"
              min="1.4"
              max="2.0"
              step="0.1"
              value={settings.lineHeight}
              onChange={(e) => updateSetting('lineHeight', Number(e.target.value))}
            />
            <span className="spacing-icon">=</span>
          </div>
        </div>

        {/* Content Width */}
        <div className="setting-group">
          <label>Width</label>
          <div className="width-options">
            {CONTENT_WIDTHS.map(width => (
              <button
                key={width.value}
                className={`width-option ${settings.contentWidth === width.value ? 'active' : ''}`}
                onClick={() => updateSetting('contentWidth', width.value as TypographySettings['contentWidth'])}
              >
                <div className={`width-preview ${width.value}`} />
                <span className="width-label">{width.label}</span>
              </button>
            ))}
          </div>
        </div>

        {/* Reset */}
        <button className="reset-btn" onClick={reset}>
          Reset to defaults
        </button>
      </div>

      {/* Preview */}
      <div className="preview-section">
        <p style={{
          fontFamily: FONT_FAMILIES.find(f => f.value === settings.fontFamily)?.css,
          fontSize: `${settings.fontSize}px`,
          lineHeight: settings.lineHeight
        }}>
          The quick brown fox jumps over the lazy dog.
        </p>
      </div>
    </div>
  )
}
